import React from "react";
import { AHText, TouchableBox, useLayoutContext, useScaleFactor } from "arkh";
import { useTeamScheduleEventItemTextSize } from "./useTeamScheduleEventItemTextSize";
import { useWidgetLayout } from "../WidgetLayoutContext";
import { WidgetTeamScheduleTimeLabelLayout } from "./WidgetTeamScheduleTimeLabelLayout";

import { useFragment, graphql } from "react-relay";

import { WidgetOverviewSize } from "./__generated__/WidgetTeamSchedule_widget.graphql";
import { CalendarEventItemListItem_eventItem$key } from "./__generated__/CalendarEventItemListItem_eventItem.graphql";

export function CalendarEventItemListItem(props: {
  eventItem: CalendarEventItemListItem_eventItem$key;
  size: WidgetOverviewSize;
  status: "active" | "soon" | "none";
  width: number;
  isDarkTint: boolean;
  onPress?(): void;
}) {
  const data = useFragment(
    graphql`
      fragment CalendarEventItemListItem_eventItem on TeamScheduleOneOffEvent {
        title
        description
      }
    `,
    props.eventItem
  );
  const sf = useScaleFactor();
  const widget = useWidgetLayout();
  const layout = useLayoutContext();
  const textSize = useTeamScheduleEventItemTextSize(
    data?.title?.length ?? 1,
    (widget.width -
      WidgetTeamScheduleTimeLabelLayout.width -
      layout.space.small) *
      sf
  );
  return (
    <TouchableBox
      style={{
        flex: 1,
        flexDirection: "column",
        justifyContent: "center",
      }}
      spaceRight="small"
      disabled={!props.onPress}
      onPress={props.onPress}
    >
      <AHText
        numberOfLines={1}
        style={{
          fontSize: textSize ? textSize * sf : undefined,
        }}
        type="title-small"
      >
        {data?.title ?? ""}
      </AHText>
      {data?.description && data.description.length > 0 ? (
        <AHText
          numberOfLines={
            props.status === "active" && props.size !== "TWO_X_ONE" ? 4 : 2
          }
          style={{
            fontSize: 14 * sf,
          }}
          color="darkerText"
        >
          {data.description}
        </AHText>
      ) : null}
    </TouchableBox>
  );
}
